import styles from './style.module.css'
import LinkComponent from '../link';
import TagsContainer from '../tags-container';
import Moment from 'react-moment';
import 'moment/locale/ru';


const NewsCard = ({
    id,
    tags,
    title,
    pub_date,
}
) => {
    return (
        <div className={styles.card}>
            <LinkComponent
                className={styles.card__title}
                href={`/news/${id}`}
                title={title}
            />
            <div className={styles.card__footer}>
                <div className={styles.pub_date}>
                    <Moment locale='ru' format='LL'>
                        {pub_date}
                    </Moment>
                </div>
                <TagsContainer tags={tags} />
            </div>
        </div>
    );
}

export default NewsCard;